import { injectable } from 'inversify';

export interface AuthHandler {
  isAuthenticated (): boolean
  hasToken (): boolean
  getToken (): string | null
  setToken (token: string): void
  clearToken (): void
}

export interface SessionHandler extends AuthHandler {
  setSession (sessionHolder: any): void
  clearSession (): void
  setValue (key: string, value: any): void
  getValue (key: string): any
  clearValue (key: string): void 
}

@injectable()
export abstract class LocalSessionHandler implements SessionHandler {
  private tokenName = 'access_token';

  public hasToken (): boolean {
    return this.getToken()?true:false;
  }

  public isAuthenticated (): boolean {
    return this.hasToken();
  }

  public getToken (): string | null {
    return localStorage.getItem(this.tokenName)
  }

  public setToken (token: string): void {
    localStorage.setItem(this.tokenName, token)
  }

  public clearToken (): void {
    return localStorage.removeItem(this.tokenName)
  }

  public setValue(key: string, value: any): void {
    this.setLocalValue(key, value)
  }

  public getValue(key: string): any {
    return this.getLocalValue(key)
  }

  public clearValue(key: string): void {
    this.removeLocalValue(key)
  }

  public abstract setSession(sessionHolder: any): void

  public abstract clearSession(): void

  protected setLocalValue(key: string, value: any): void {
    localStorage.setItem(key, value)
  }

  protected getLocalValue(key: string): any {
    return localStorage.getItem(key)
  }

  protected removeLocalValue(key: string): void {
    localStorage.removeItem(key)
  }
}

@injectable()
export class Auth0Handler extends LocalSessionHandler {
  public setSession (authResult: any): void {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    )
    this.setToken(authResult.accessToken)
    this.setLocalValue('id_token', authResult.idToken)
    this.setLocalValue('expires_at', expiresAt)
  }

  public clearSession (): void {
    // Clear access token and ID token from local storage
    this.clearToken()
    this.removeLocalValue('access_token')
    this.removeLocalValue('id_token')
    this.removeLocalValue('expires_at')
  }

  public getToken (): string | null {
    return this.isAuthenticated() ? super.getToken() : null
  }

  public isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(<string>localStorage.getItem('expires_at'))
    return new Date().getTime() < expiresAt
  }
}